import { Notification } from "ant-design-vue";

const restApiDispatcher = (
  context,
  {
    storeKey,
    action,
    loadingKey,
    resource,
    commitType,
    params,
    metaKey,
    message = "",
    silent = false
  }
) => {
  context.commit("PENDING", loadingKey);
  return resource[action](params)
    .then(response => {
      const {
        data: { data, results, unReadNotifications },
        headers = {}
      } = response;
      context.commit("SUCCESS", {
        resource,
        storeKey,
        metaKey,
        data,
        results,
        headers,
        unReadNotifications,
        action: commitType || action
      });
      if (!message) return;
      Notification.success({ message, duration: 3 });
    })
    .catch(err => {
      if (!err.response) {
        Notification.error({
          message: "Server Is Offline",
          description: "Please Try Again Later"
        });
      }
      if (hasMatchingErrors(err.response.status)) {
        errorHandler[err.response.status](err.response);
      }
      if (silent) {
        throw err;
      }
      Notification.error({
        message: "Error",
        description: err.response.data.message
      });
      throw err;
    })
    .finally(() => {
      context.commit("RESOLVE_PENDING", loadingKey);
    });
};
const hasMatchingErrors = statusCode => {
  const ERROR_CODES = [404, 500, 403, 411];
  return ERROR_CODES.includes(statusCode);
};

const errorHandler = {
  403: response => reRoutePage(response.status, response.data.message),
  404: response => reRoutePage(response.status, response.data.message),
  420: response => reDirectLogin(response),
  411: () => logoutUser(),
  500: response => errMessage(response.data.message),
};

const errMessage = errMsg => {
  Notification.error({
    message: errMsg,
  })
}

const reRoutePage = (statusCode, errorMessage) => {
  sessionStorage["error-message"] = errorMessage;
  window.location.replace(`${window.location.origin}/${statusCode.toString()}`);
};

const logoutUser = () => {
  localStorage.clear();
  window.location.replace(`${window.location.origin}/login`);
};

const reDirectLogin = response => {
  localStorage.clear();
  let loginUrl = `${window.location.origin}/login`;
  let url = new URL(loginUrl);
  url.searchParams.set("password_changed", true);
  sessionStorage["message"] = response.data.message;
  window.location.href = url.href;
};

export default restApiDispatcher;
